import React from 'react'
import cloneDeep from 'lodash/clone';
import { latest as API_URL } from '../config/api';
import moment from 'moment';
import { isChecked, number_format, panels, searchItem } from '../config/Helpers';
import ListDynamic from '../reports/ListDynamic';
import ExportReport from '../reports/ExportReport';
import { Icon, Popconfirm, message, Button, Select, Drawer } from 'antd';
import ListFixed from '../reports/ListFixed';
import { HashLink as Link } from 'react-router-hash-link';
import axios from 'axios';
import { ModalUpgrade } from "./LiteComponents";


const postUrlDimensions  = API_URL + 'dimensions';
const postUrlSidebarCatalogs  = API_URL + 'sidebar-catalogs';

class SidebarLeft extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            catalogs_active : {},
            catalogs_list : [],
            catalogs_filter : [],
            catalogs_filter_copy : [],
            sidebar_loading_general : ' ',
            sidebar_loading_item : true,
            request_status : true,
            current_side : '',
            sidebar_active : 'inactive-sidebar',
            filter_value_segment : '',
            filter_value_property : '',
            filters_permanent_backup : {},
            _report : {
                active : false,
                edit : false,
                share : false
            },
            select_module : '',
            first_load : true
        };
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.getFilters = this.getFilters.bind(this)
        this.getResetValues = this.getResetValues.bind(this);
    }
    
    getDefaultValues(){
        return {
            catalogs_active : {},
            //catalogs_filter : [],
            //catalogs_filter_copy : [],
            sidebar_active : 'inactive-sidebar',
            sidebar : '',
            //sidebar_loading_general : ' ',
            current_side : '',
        };
    }
    getResetValues(){
        return {
            catalogs_active : {},
            //catalogs_filter : [],
            //catalogs_filter_copy : [],
            //sidebar_loading_general : ' ',
            sidebar_loading_item : true,
            current_side : '',
            sidebar_active : 'inactive-sidebar',
            filter_value_segment : '',
            filter_value_property : '',
            _report : {
                active : false,
                edit : false,
                share : false
            },
            select_module : ''
        }
    }
    getFilters(){
        if(this.props.app.state.new_date === false){
            return;
        }
        let self = this;
        var qs = require('qs');
        self.setState({
            sidebar_loading_general : ((self.state.first_load === true) ? ' ' : ' hide'),
            sidebar_loading_item : false
        }, function(){
            axios.post(postUrlDimensions, qs.stringify(self.props.app.currentFilters({ type : 'sidebar' })))
            .then(function (response){ 
                self.setState({ 
                    catalogs_filter : response.data['catalogs_filter'],
                    catalogs_filter_copy : response.data['catalogs_filter'],
                    mount : true,
                    sidebar_loading_general : ' hide',
                    first_load : false,
                    sidebar_loading_item : true
                }) 
            })
        })
    }
    confirm(edit = false) {
        let self = this

        this.setState({
            _report : {
                active : true,
                edit : edit,
                share : false
            },
        }, function(){
            this.props.app.setState((prev) => {
                return {
                    report_context : {
                        _id : prev.report_context._id, 
                        status : true,
                        className : 'report-context',
                        name : prev.report_context.name,
                        type_report : prev.report_context.type_report,
                        analysis_interval : prev.report_context.analysis_interval,
                        notify_email :prev.report_context.notify_email,
                        startValue : prev.report_context.startValue,
                        endValue : prev.report_context.endValue,
                        created_at : prev.report_context.created_at,
                        updated_at : prev.report_context.updated_at,
                        days_fixed_report : prev.report_context.days_fixed_report,
                        share : prev.report_context.share
                    }
                }
            }, function(){
                if(edit === true){
                    self.props.app.mainRequest();
                }else{
                    message.info('Now you can create your report');
                }
                self.handleClickSidebar('dimensions')
            })
        })
      }

    handleClickModal(type){
        let self = this;
        this.props.app.reportModelState(type)
    }

    filterDimensionByText(ref_state, event){
        let filter = event.target.value;
        let copy = Object.assign({}, this.state.catalogs_filter_copy);
        copy[ref_state] = this.state.catalogs_filter_copy[ref_state]
        this.setState({
            catalogs_filter : copy  
        }, function(){
            let array_elements = copy[ref_state].filter(function(elem) {
                return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
            });
            if(filter === ''){
                this.setState({
                    catalogs_filter : copy
                })
            }else{
                copy[ref_state] = array_elements
                this.setState({
                    catalogs_filter : copy
                })
            }
        })
    }
    handleClickSidebar(sidebar) {
        let self = this;
        let state_sidebar;
        const is_report = (sidebar === 'models' || sidebar === 'reports') ? ' is-report' : '';
        this.setState(function(prev){
            if(self.state._report.active === false){
                if(prev.sidebar_active === 'active-sidebar' + is_report && prev.current_side === sidebar){
                    state_sidebar = 'inactive-sidebar';
                    sidebar = '';
                }else{
                    state_sidebar = 'active-sidebar' + is_report;
                    if(is_report === ' is-report'){ 
                        this._ListFixed.syncReports(); 
                    }
                }
            }else{
                state_sidebar = 'active-sidebar';
                sidebar = 'dimensions';
            }
            return {
                sidebar_active : state_sidebar, 
                current_side : sidebar 
            }
        }, () => {
            if(self.state.sidebar_active !== 'active-sidebar'){
                let filters_apply = [];
                Object.keys(self.props.app.state.filters_apply).map(function(key){
                    filters_apply[key] = cloneDeep(self.props.app.state.filters_apply[key])
                })
                self.props.app.setState({
                    filters_permanent : filters_apply
                })
            }
            this.props.app.activeSidebar(state_sidebar)
        }); 
    }
    handleClickMenuItem(item, type){    
        let array_elements = this.props.app.state.filters_permanent[type], self = this;
        if(array_elements !== null){
            if(searchItem(item.value, array_elements) === -1){
                self.props.app.setFilterBubble(item, type)
            }else{
                self.props.app.setFiltersComponent(item, type)
            }
        }else{
            self.props.app.setFilterBubble(item, type)
        }
    } 
    handleClickItemSidebar(catalog) {
        let self = this;
        let new_state = self.state.catalogs_list;
        Object.keys(self.state.catalogs_list).map(function(key){
            if(self.state.catalogs_list[key].id === catalog){
                new_state[key].status  = self.state.catalogs_list[key].status === 'active' ? 'inactive' : 'active';
            }else{
                new_state[key].status  = 'inactive'
            }
        });

        self.setState({
            catalogs_list : new_state
        })
    }
    
    cancelReport(){
        let msg = this.state._report.edit === false ? 'The report has been canceled.' : 'The report has been closed.';
        message.info(msg);
        this.setState(function(){
            return {
                _report : {
                    active : false,
                    edit : false,
                    share : false
                }
            }
        }, function(){
            this.props.app.setState({
                mode_report : {
                    status : false,
                    _is_share : false,
                    _is_interactive : false,
                    _is_invited : false,
                    _dashboards_select : {},
                    _allow_export : 0
                },
                report_context : {
                    status : false,
                    name : '',
                    type_report : '',
                    className : '',
                    notify_email : 0,
                    allow_export : 0,
                    datepicker : '',
                    days_fixed_report : ''
                }
            })
        })
    }
    componentWillMount(){
        const qs = require('qs');
        let self = this;
        axios.post(postUrlSidebarCatalogs,  qs.stringify({ api_token: localStorage.getItem("api_token") }))
        .then(function (response){ 
            self.setState({
                catalogs_active : response.data
            }, function(){
                let catalogs_active = this.state.catalogs_active;

                Object.keys(catalogs_active).map(function(key){
                    //if(catalogs_active[key].id !== "tariff_type"){
                        self.props.app.state.filters_apply[catalogs_active[key].id] = []
                        self.props.app.state.filters_permanent[catalogs_active[key].id] = []
                        self.props.app.state.filters_apply_backup[catalogs_active[key].id] = []
                        self.props.app.state.filters_permanent_backup[catalogs_active[key].id] = []
                        self.state.catalogs_list[key] = {
                            name : catalogs_active[key].name['en'],
                            id : catalogs_active[key].id,
                            status : 'inactive',
                            props : {}
                        }
                    //}
                })
                self.props.app.state.filters_apply['property'] = []
                self.props.app.state.filters_permanent['property'] = []
                self.props.app.state.filters_apply_backup['property'] = []
                self.props.app.state.filters_permanent_backup['property'] = []
            })
        })
    }
    componentWillReceiveProps(){
        let self = this;
        if(self.props.app.state.mode_report !== null){
            const Option = Select.Option;
            let _index = 0;
            const listPanels = Object.keys(panels).map((item, index) => {
                let panel_include = false, 
                panel_dashboards = self.props.app.state.mode_report._dashboards_select,
                _params_module = {};
                Object.keys(panel_dashboards).map((key, index) => {
                    let _decode = JSON.parse(panel_dashboards[key])
                    if(_decode._panel === panels[item]._value){
                        _params_module = _decode._params_module
                        panel_include = true
                    }
                })
                if(panel_include === true){
                    if(_index === 0){
                        this.state.current_panel = { _name: panels[item]._name, _icon: panels[item]._icon + '-active', _value: panels[item]._value }
                        _index++;
                    }
                    return (<Option 
                        key={panels[item]._value}
                        onClick={self.props.app._widgetHeader.handleClickMenuItem.bind(self, { _name: panels[item]._name, _icon: panels[item]._icon + '-active', _value: panels[item]._value }, 'menu_panel', _params_module)}
                    >{panels[item]._name}</Option>)
                }
            });
        
            let select_module = (
                <Select 
                    className='select-modules' style={{width : '100%'}} 
                    defaultValue={ (function(){ 
                        if(self.props.app._widgetHeader === undefined || self.props.app._widgetHeader === null){
                            return 'review'
                        } else{
                            return self.props.app._widgetHeader.state.current_panel._value
                        }
                    })()}>
                    {listPanels}
                </Select>
            );
            this.setState({
                select_module : select_module
            })
        }
    }
    render(){
        let self = this, catalogs_list = this.state.catalogs_list, filters = []; 

        Object.keys(catalogs_list).map(function(key){
            const id = catalogs_list[key].id;
            let filters_child = self.state.catalogs_filter[id] === undefined ? '' : self.state.catalogs_filter[id].map(function(item, index){
                return (<li key={'filter-' + id + '-'+index} onClick={self.handleClickMenuItem.bind(self, { str: item.name, value: item._id }, id)} >
                    <span className='title-list' title={item.name}>
                        { item.name.length > 28 ? item.name.substr(0,28) + " [...]" : item.name} 
                        {
                            (self.state.sidebar_loading_item === true) ? 
                            <span style={{marginLeft : "5px"}} className='total-by-filter' children={`(${number_format(item.total,0)})`}/> : 
                            <Icon style={{marginLeft : "5px"}} type='sync' spin />
                        }
                        
                        <input type='checkbox' 
                            value={ index } 
                            checked={isChecked((typeof(self.props.app.state.filters_permanent[id]) !== 'undefined') ? self.props.app.state.filters_permanent[id] : [], item._id)} 
                        />
                        <span className='checkmark'></span>
                    </span>
                </li>)
            });
            if(self.state.catalogs_filter[id] !== undefined){
                filters[id] = (<li className={catalogs_list[key].status}>
                    <span onClick={self.handleClickItemSidebar.bind(self, id)} children={catalogs_list[key].name} />
                    <div className='sub-list'>
                        <div className=''>
                            <input 
                                type='text' 
                                onChange={self.filterDimensionByText.bind(self, id)}  
                                placeholder='Search...'
                            />
                        </div>
                        <ul>
                            { filters_child }
                        </ul>
                    </div>
                </li>)
            }
        })
    
        const original_padding = (this.props.app.isInvitedUser() === false) ?  { style : { paddingTop : 15 } } : null;
        return(
            <section ref={ref => { this.sidebar_filters = ref }} id='container-sidebar' {...original_padding} className={'sidebar-left ' + this.state.sidebar_active + ' ' + this.props.app.state.secondary_filter_bar}>
                { this.props.app.isInvitedUser() ?
                (<div className={'filters-section'}>
                    <div className={'loading-sidebar ' + ((self.state.sidebar_loading_item === true) ? "hide": "") }>
                        <Icon type='sync' spin />
                    </div>
                    <div className={(this.state._report.active === false ? '' : ' hide')} onClick={this.handleClickSidebar.bind(this, 'dimensions')}>
                        <a className='dimensions'><i className='fa fa-filter' aria-hidden='true'></i></a>
                        <span>FILTERS </span>
                        <Icon type='close' theme='outlined' className={'close-wdg ' + (this.state.current_side === 'dimensions' ? 'show' : 'hide')}/>
                    </div>
                    <ul className={ this.state.current_side === 'dimensions' ? 'active' : '' }>
                        {
                            Object.keys(filters).map(function(key_catalog){
                                return filters[key_catalog]
                            })
                        }
                    </ul>
                    {
                        (Object.keys(self.state.catalogs_filter).length > 0) ? 
                        (<Button type="primary" disabled={self.state.request_status === "" ? true : false} style={{marginBottom : '15px'}} className={ this.state.current_side === 'dimensions' ? '' : 'hide' } block onClick={() => {
                        Object.keys(self.props.app.state.filters_permanent).map(function(key){
                            self.props.app.state.filters_apply[key] = cloneDeep(self.props.app.state.filters_permanent[key])
                        })
                        setTimeout(() => {
                            self.props.app.defaultValuesRequest();
                        }, 500);
                    }}>Apply</Button>) : null
                    }
                    
                </div>) : 
                ( <div className='report-options-view'>
                    <Link to='/'><span className='logo-sidebar'> </span></Link>
                    <br />
                    <span className='subtitle'>AVAILABLY MODULES</span>
                    {this.state.select_module}
                </div> ) 
                }

                { /*<div>
                    <a className='expressions' onClick={this.handleClickSidebar.bind(this)}> <i className='fa fa-list-alt' aria-hidden='true'></i> </a>
                    <span>EXPRESIONES</span>
                </div> */ }
                <div className={ (this.state.current_side === 'reports' ? 'active' : '') + (this.state._report.active === false ? '' : ' hide') }>
                    <div onClick={ () => {
                        if(this.props.app.state.lite === false){
                            this.handleClickSidebar('reports')
                        }else{
                            ModalUpgrade();
                        }
                        
                        }}>
                        <a className='reports'> <i className='fa fa-clipboard' aria-hidden='true'></i> </a>
                        <span>REPORTS</span>
                        <Icon type='close' theme='outlined' className={'close-wdg ' + (this.state.current_side === 'reports' ? 'show' : 'hide')}/>
                    </div>
                    <ListFixed 
                        currentFilters = {this.props.app.currentFilters}
                        status={(this.state.current_side === 'reports' ? 'active' : '')}
                        layout={this}
                        app={this.props.app}
                        ref={(child) => { this._ListFixed = child; }}
                    />
                </div>
                <div>
                    <div className={this.state._report.active === true ? '' : ' hide'} >
                        <span className={this.state._report.active === false ? '' : ' hide'}>REPORT</span>
                                {
                                    this.props.app.state.report_context.name !== "" ? 
                                        <h4 className="report-name-active" style={{textAlign : 'left'}}>
                                            <span className="title">STATUS REPORT</span>
                                            <span>REPORT NAME: {this.props.app.state.report_context.name}</span>
                                            <span style={{marginTop : '10px'}}>CREATED AT: {this.props.app.state.report_context.created_at}</span>
                                            <span style={{marginTop : '10px'}}>LAST UPDATED: {this.props.app.state.report_context.updated_at != null ? this.props.app.state.report_context.updated_at : this.props.app.state.report_context.created_at}</span>
                                            { this.props.app.state.report_context.share !== null ? (
                                                <div className="share-info">
                                                    <span style={{fontStyle : 'italic'}}>
                                                       [SHARE REPORT]
                                                    </span>
                                                    <span style={{marginTop : '10px'}}>
                                                       SHARE BY: { this.props.app.state.report_context.share.user }
                                                    </span>
                                                    <span style={{marginTop : '10px'}}>
                                                       EXPIRE DATE: { this.props.app.state.report_context.share.expire_date }
                                                    </span>
                                                </div>) : null 
                                            }
                                            
                                                <div style={{textAlign : 'right', marginTop : '15px', borderTop: '1px solid #CCC', padding : '10px'}}>
                                                {
                                                    (
                                                        (this.state._report.edit === true && this.props.app.state.mode_report._is_share === false) || 
                                                        (this.props.app.state.mode_report._allow_export === 1 && this.props.app.state.mode_report._is_share === true) ||
                                                        (this.props.app.state.mode_report._allow_export === 1 && this.props.app.state.mode_report._is_invited === true)
                                                    ) ? 
                                                        <Button 
                                                            style={{ 
                                                                fontSize : 12, 
                                                                letterSpacing : 1,
                                                                float : 'left',
                                                                //display : 'none'
                                                            }} 
                                                            type='default'
                                                            icon='export'
                                                            size='small'
                                                            onClick={() => {
                                                                this._ExportReport.setState({
                                                                    visible : true
                                                                })
                                                            }}>
                                                                EXPORT
                                                            </Button> :
                                                        ''
                                                }
                                                    { this.props.app.state.report_context.share === null ? (<Button 
                                                        type='primary' 
                                                        size='small' 
                                                        style={{ fontSize : 12, letterSpacing : 1}} 
                                                        onClick={this.handleClickModal.bind(this, (this.state._report.edit === true ? 'reports-edit' : 'reports-new'))} 
                                                        children={'UPDATE'} /> ) : null
                                                    }
                                                    <Button 
                                                        type='danger' 
                                                        size='small' 
                                                        style={{ 
                                                            fontSize : 12, 
                                                            letterSpacing : 1, 
                                                            marginLeft : '5px'
                                                        }} 
                                                        onClick={this.cancelReport.bind(this)}
                                                        children={'CLOSE'} />
                                                </div>
                                            
                                        </h4> : null
                                }
                                
                               
                            {   ((this.props.app.state.mode_report.status === false || 
                                this.props.app.state.mode_report._is_share === false) &&
                                this.state._report.edit !== true) ?
                                (<Button 
                                    type='primary' 
                                    size='default' 
                                    style={{ fontSize : 12, letterSpacing : 1, width : '100%'}} 
                                    onClick={this.handleClickModal.bind(this, (this.state._report.edit === true ? 'reports-edit' : 'reports-new'))} 
                                    children={ 'SAVE REPORT'} />) : null
                            }
                            {
                                (this.props.app.state.mode_report._is_invited === false && this.state._report.edit !== true) ? 
                                    (<Button 
                                        type='danger' 
                                        size='default' 
                                        style={{ 
                                            fontSize : 12, 
                                            marginTop : 10, 
                                            letterSpacing : 1, 
                                            width : '100%'
                                        }} 
                                        onClick={this.cancelReport.bind(this)}
                                        children={'CANCEL REPORT'} />) : null
                            }
                    </div>
                    {(this.props.app.state.lite === false) ? (
                    <Popconfirm placement='rightTop' style={{width : 150}} title={<p>Some functions will be disabled.<br />Are you sure to activate the report generation context?</p>} onConfirm={this.confirm.bind(this, false)} okText='Yes' cancelText='No'>
                        <div className={(this.state._report.active === false ? '' : ' hide')}>
                            <a className='models'> <i className='fa fa-save' aria-hidden='true'></i> </a>
                            <span>NEW REPORT</span>
                        </div>
                    </Popconfirm>) : (<div onClick={() => {
                        ModalUpgrade();
                    }} className={(this.state._report.active === false ? '' : ' hide')}>
                            <a className='models'> <i className='fa fa-save' aria-hidden='true'></i> </a>
                            <span>NEW REPORT</span>
                        </div>)
                    }
                </div>
                <div className='with-love'>
                    <div>
                        <span>Made with <i className='fa fa-heart'></i> by Axovia</span>
                    </div>
                </div>
                <ExportReport app={this.props.app} ref={(child) => { this._ExportReport = child; }} />
            </section>
        )
    }
}

export default SidebarLeft



// WEBPACK FOOTER //
// ./src/Frontend/components/SidebarLeft.js